import React, { useMemo } from "react";

import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Select from "nlib/ui/Select";
import UserStatuses from "const/UserStatuses";

const SelectUserStatus = ({ filter, ...props }) => {
  const { uiTexts } = useSelector(getTextsData);

  const options = useMemo(() => {
    return [
      { value: UserStatuses.APPROVED, label: uiTexts.active },
      { value: UserStatuses.PENDING, label: uiTexts.pending },
      filter && { value: null, label: uiTexts.all }
    ].filter(Boolean);
  }, [filter, uiTexts]);

  return (
    <Select
      placeholder={uiTexts.selectStatus}
      options={options}
      {...props} />
  );
};

export default React.memo(SelectUserStatus);
